export const TIMES_USED_BY_GROUP = 'timesUsedByGroup';
export const FUNCTION_OR_QUERY = ['function', 'query'];
export const TIMES_USED = 'timesUsed';
